module.exports = __webpack_public_path__ + "a0f4a4df23e3ab39233ae8f0f3013506.jpg";